<template>
  <nav class="sidebar-menu-wrapper">
    <div class="sideNav sidebar-level mp-level mp-level-open" :class="activeParent ? 'paddingTopUnset' : ''">
      <div class="row align-items-center activeParentCloseArea">
        <div v-if="activeParent" class="col my-3">
          <button type="button" class="close previousLink mp-back" @click="goBack">
            <a href="#">{{ activeParent.name }}</a>
          </button>
        </div>
        <div class="col-auto ml-auto">
          <button type="button" aria-label="Close" class="close btnClose" @click="$emit('closeSideBar')">
            <span>
              <img src="../../public/src/images/sidebar-menu-close.svg" alt="sidebar-menu-close" />
            </span>
          </button>
        </div>
      </div>
      <div class="menu-content-container">
        <transition :name="transitionName">
          <ul :key="JSON.stringify(currentLevelKey)" class="navbar-nav">
            <li v-for="(item, index) in filteredMenu" :key="index" class="nav-item dropDown">
              <span class="nav-link" @click="handleClick(item)">
                <i v-show="hasChildren(item)" class="fas fa-chevron-right"></i>
                <span>{{ item.name }}</span>
              </span>
            </li>
          </ul>
        </transition>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "SidebarMenu",
  props: {
    menuItems: {
      type: Array,
      required: true,
    },
    pagePermissionsMap: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      stack: [],
      currentMenu: this.menuItems,
      direction: "forward",
    };
  },
  computed: {
    filteredMenu() {
      return Array.isArray(this.currentMenu)
        ? this.currentMenu.filter((item) => {
            if (item.existsInLoggedInUserResources && item.children.length > 0) {
              return true;
            } else if (this.pagePermissionsMap[item.pagePermissionTag]) {
              return this.pagePermissionsMap[item.pagePermissionTag];
            } else {
              return false;
            }
          })
        : [];
    },
    activeParent() {
      return this.stack.length > 0 ? this.stack[this.stack.length - 1] : null;
    },
    currentLevelKey() {
      return this.stack.length;
    },
    transitionName() {
      return this.direction === "forward" ? "slide-forward" : "slide-backward";
    },
  },
  methods: {
    hasChildren(item) {
      const children = Array.isArray(item.children) ? item.children : item.children ? Object.values(item.children) : [];
      return children.length > 0;
    },
    handleClick(item) {
      const children = Array.isArray(item.children) ? item.children : item.children ? Object.values(item.children) : [];
      if (children.length > 0) {
        this.direction = "forward";
        this.stack.push(item);
        this.currentMenu = children;
      } else if (item.route) {
        if (item.reportId) {
          this.$emit("loadReport", item.reportId);
        } else {
          if (this.$route.path !== item.route) {
            this.$router.push(item.route);
            this.$emit("closeSideBar");
          }
        }
      }
    },
    goBack() {
      this.direction = "backward"; // Geri animasyonu
      this.stack.pop();
      const parent = this.stack[this.stack.length - 1];
      const children = parent ? (Array.isArray(parent.children) ? parent.children : Object.values(parent.children)) : this.menuItems;
      this.currentMenu = children;
    },
  },
};
</script>

<style scoped>
.menu-content-container {
  position: relative;
  height: calc(100% - 60px);
  overflow: hidden;
}

/* Update your animation styles */
.slide-forward-enter-active,
.slide-forward-leave-active,
.slide-backward-enter-active,
.slide-backward-leave-active {
  position: absolute;
  width: 100%;
  transition: transform 0.3s ease;
}

/* Forward animation */
.slide-forward-enter-from {
  transform: translateX(100%);
}

.slide-forward-enter-to {
  transform: translateX(0);
}

.slide-forward-leave-from {
  transform: translateX(0);
}

.slide-forward-leave-to {
  transform: translateX(-30%);
}

/* Backward animation */
.slide-backward-enter-from {
  transform: translateX(-30%);
}

.slide-backward-enter-to {
  transform: translateX(0);
}

.slide-backward-leave-from {
  transform: translateX(0);
}

.slide-backward-leave-to {
  transform: translateX(100%);
}

.sidebar-menu-wrapper {
  width: 372px;
  background: #fff;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  height: 100vh;
  transition: all 0.3s ease;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  @media (max-width: 575px) {
    width: calc(100% - 47px);
  }
}

.activeParentCloseArea {
  width: 100%;
  height: 100px;
  justify-self: center;
}

.paddingTopUnset {
  padding-top: unset !important;
}

.nav-item:last-child {
  padding-bottom: 35px;
}

.nav-link {
  transition-duration: 0.3s;
  font-size: 16px;
  font-weight: 500;
  line-height: 2;
  color: var(--blue-grey);
  padding: 21px 0;
  cursor: pointer;
}

.nav-link:hover {
  color: var(--light-royal-blue);
  transition-duration: 0.3s;
}

.sidebar-header {
  display: flex;
  align-items: center;
  padding: 10px;
  background: #f0f0f0;
  font-weight: bold;
}

.back-btn {
  margin-right: 10px;
  cursor: pointer;
  background: none;
  border: none;
  font-size: 16px;
}

/* Animation for sliding the new menu over the old one */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(100%);
}

/* Ensuring that each menu level appears on top of the previous one */
.sidebar-level {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}

.navbar-nav {
  height: calc(100% - 45px);
  overflow-y: auto;
  margin: 0;
  padding: 0 0 20px 0;
  list-style: none;
  flex: 1;
}

/* İleri animasyonu (soldan sağa) */
.slide-forward-enter-active,
.slide-forward-leave-active {
  transition: transform 0.3s ease;
}

.slide-forward-enter {
  transform: translateX(100%);
}

.slide-forward-leave-to {
  transform: translateX(-100%);
}

/* Geri animasyonu (sağdan sola) */
.slide-backward-enter-active,
.slide-backward-leave-active {
  transition: transform 0.3s ease;
}

.slide-backward-enter {
  transform: translateX(-100%);
}

.slide-backward-leave-to {
  transform: translateX(100%);
}

.sideNav {
  box-shadow: 0 15px 30px 0 rgba(35, 48, 83, 0.1) !important;
  background-color: #fff;
  margin: 0;
  border: 0;
  border-radius: 0;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  -ms-border-radius: 0;
  -o-border-radius: 0;
  transform: none !important;
  -webkit-transform: none !important;
  -moz-transform: none !important;
  -ms-transform: none !important;
  -o-transform: none !important;

  .mp-level {
    background-color: #fff;
  }

  .previousLink {
    display: flex;
    align-items: center;
    float: left;
    margin-left: 13px;
    opacity: 1 !important;

    &:focus {
      outline: 0;
    }

    &::before {
      content: "";
      display: flex;
      width: 38px;
      height: 36px;
      background-color: #f2f2f2;
      min-width: 38px;
    }

    &::after {
      content: "";
      display: flex;
      color: var(--light-royal-blue);
      background-color: transparent;
      border-top: 2px solid !important;
      border-right: 2px solid !important;
      width: 12px;
      height: 12px;
      border-left: none !important;
      border-bottom: none !important;
      position: absolute;
      left: 16px;
      cursor: pointer;
      transform: rotate(225deg);
      top: 50%;
      margin-top: -6px;
    }

    a {
      color: var(--light-royal-blue);
      padding-left: 14px;
      font-size: 18px;
      font-weight: 600;
      @media (max-width: 576px) {
        font-size: 16px;
      }
    }
  }

  .btnClose {
    margin-right: 14px;
    opacity: initial;

    &:focus {
      outline: 0;
    }

    &:hover {
      opacity: 1;
    }
  }

  ul {
    .dropDown {
      i {
        float: right;
        margin-top: 8px;
        @media (max-width: 576px) {
          margin-top: 2px;
        }
      }

      &:hover {
        &::after {
          color: var(--light-royal-blue) !important;
          transition-duration: 0.3s;
        }
      }
    }

    li {
      border-top: 1px solid var(--light-periwinkle-two);
      margin-left: 30px;
      margin-right: 30px;
    }

    a {
      transition-duration: 0.3s;
      font-size: 16px;
      font-weight: 500;
      line-height: 2;
      color: var(--blue-grey);
      padding: 21px 0;

      @media (max-width: 576px) {
        font-size: 14px;
        line-height: 1.35;
        padding: 12px 0;
      }

      &:hover {
        color: var(--light-royal-blue);
        transition-duration: 0.3s;
      }
    }
  }
}

.mp-level .mp-level-open ul {
  height: calc(100% - 105px);
  overflow: scroll;
}

// css içindekiler start
.mp-level {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
}

.mp-pusher::after,
.mp-level::after,
.mp-level::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  opacity: 0;
}

.mp-pusher::after,
.mp-level::after {
  background: rgba(0, 0, 0, 0.3);
  -webkit-transition: opacity 0.3s, width 0.1s 0.3s, height 0.1s 0.3s;
  transition: opacity 0.3s, width 0.1s 0.3s, height 0.1s 0.3s;
}

.mp-level::after {
  z-index: -1;
}

.mp-pusher.mp-pushed::after,
.mp-level.mp-level-overlay::after {
  width: 100%;
  height: 100%;
  opacity: 1;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
}

.mp-level.mp-level-overlay {
  cursor: pointer;
}

.mp-level.mp-level-overlay.mp-level::before {
  width: 100%;
  height: 100%;
  background: transparent;
  opacity: 1;
}

.mp-pusher,
.mp-level {
  -webkit-transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
}

.mp-back {
  position: relative;
  display: block;
  outline: none;
  color: #fff;
}

.mp-back::after {
  content: "\e037";
  position: absolute;
  right: 10px;
  color: rgba(0, 0, 0, 0.3);
  font-size: 1.3em;
  font-family: "linecons";
}

// css içindekiler end
</style>
